import React from "react";
import { Trans } from "react-i18next";
import useAppTranslations from "../hooks/useAppTranslations";
import { TranslationNamespace, TranslationSource } from "../i18n";

interface ITranslateProps<TInterpolationMap = any> {
  src: TranslationSource;
  ns?: TranslationNamespace;
  values?: TInterpolationMap;
  components?: {
    readonly [tagName: string]: React.ReactElement;
  };
}

export default function Translate<TInterpolationMap = any>({
  src,
  ns,
  values,
  components
}: ITranslateProps<TInterpolationMap>) {
  const { ns: appNS } = useAppTranslations(ns);

  return <Trans i18nKey={src} values={values as object} components={components} ns={appNS} />;
}
